import { useEffect } from "react";

export function ApresentacaoPdf() {
  useEffect(() => {
    // Faz o download automático do PDF
    const urlPdf = process.env.REACT_APP_PUBLIC_URL + "apresentacaoempresas.pdf";
    console.log("Download PDF from:", urlPdf);
    window.location.href = urlPdf;
  }, []);

  return null;
}
